import { ReactComponent as NoDataFound } from 'shared/assets/images/components/emptyState/noDataFound.svg';
import { InfoTemplate } from 'shared/components/InfoTemplate';

import type { FC } from 'react';
import type { InfoTemplateProps } from 'shared/components/InfoTemplate/InfoTemplate';

export const EMPTY_STATE_TEST_ID = 'empty-state';

export type EmptyStateProps = Omit<
  InfoTemplateProps,
  'data-testid' | 'children'
>;

export const EmptyState: FC<EmptyStateProps> = props => (
  <InfoTemplate data-testid={EMPTY_STATE_TEST_ID} {...props}>
    {/* TODO: add aria-label after an accessibility research */}
    {imageProps => <NoDataFound {...imageProps} />}
  </InfoTemplate>
);
